// extracted by mini-css-extract-plugin
export default {"list":"faqPopular_list__WVmry","icon":"faqPopular_icon__MqfNz"};